import React from "react";
import Select from "react-select";
import FormControl from "@material-ui/core/FormControl";
import "./forms.scss";

const customStyles = {
  control: (styles, state) => ({
    ...styles,
    boxShadow: "none",
    border: state.isFocused ? "2px solid #309d34" : " 2px solid #efefef",
    "&:hover": {
      border: state.isFocused ? "2px solid #309d34" : " 2px solid #efefef",
    },
    borderRadius: "0",
  }),
  option: (styles, state) => ({
    ...styles,
    color: state.isSelected ? "#FFF" : styles.color,
    backgroundColor: state.isSelected ? "#309d34" : styles.color,
    "&:hover": {
      color: "#FFF",
      backgroundColor: "#309d34",
    },
  }),
};

const customFilterOption = (option, rawInput) => {
  const words = rawInput.split(" ");
  return words.reduce(
    (acc, cur) => acc && option.label.toLowerCase().includes(cur.toLowerCase()),
    true
  );
};

const SelectInput = ({
  name,
  options,
  defaultValue,
  placeholder,
  onChange,
}) => {
  return (
    <FormControl>
      <Select
        className={name}
        styles={customStyles}
        name={name}
        options={options}
        defaultValue={defaultValue}
        isMulti
        placeholder={placeholder}
        filterOption={customFilterOption}
        onBlur={(event) => event.preventDefault()}
        noOptionsMessage={() => "nichts gefunden"}
        onChange={onChange}
      />
    </FormControl>
  );
};
export default SelectInput;
